/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
/**
 * Check if a given object implements the BookingAssetInfo interface.
 */
export function instanceOfBookingAssetInfo(value) {
    return true;
}
export function BookingAssetInfoFromJSON(json) {
    return BookingAssetInfoFromJSONTyped(json, false);
}
export function BookingAssetInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'assetId': json['AssetId'] == null ? undefined : json['AssetId'],
        'refSlot': json['RefSlot'] == null ? undefined : json['RefSlot'],
        'selected': json['Selected'] == null ? undefined : json['Selected'],
        'assetUrl': json['AssetUrl'] == null ? undefined : json['AssetUrl'],
        'assetText': json['AssetText'] == null ? undefined : json['AssetText'],
        'assetEffectConfig': json['AssetEffectConfig'] == null ? undefined : json['AssetEffectConfig'],
    };
}
export function BookingAssetInfoToJSON(json) {
    return BookingAssetInfoToJSONTyped(json, false);
}
export function BookingAssetInfoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AssetId': value['assetId'],
        'RefSlot': value['refSlot'],
        'Selected': value['selected'],
        'AssetUrl': value['assetUrl'],
        'AssetText': value['assetText'],
        'AssetEffectConfig': value['assetEffectConfig'],
    };
}
